import { connect } from 'react-redux'
import { AppStateType } from '../../reducers'
import { selectLanguages } from '../../selectors/languages'
import { CreatePackForm as Form } from './CreatePackForm'

const mapStateToProps = (state: AppStateType) => ({
  languages: selectLanguages(state),
})

export const CreatePackForm = connect(mapStateToProps)(Form)
